<template>
  <div class="hello">

    <transition name="fade">
        <div v-if="addingRep" class="loading">
            <p>{{performingMessage}}</p>
            </div>
    </transition>

    <!-- Modal to rep already exists -->
    <b-modal id="modal-repexists" ok-only title="Error" ok-title="OK">
        {{errMsg}}
    </b-modal>

    <b-container>
        <b-row>
            <b-col>
                <h4 style="margin-top:20px">Representatives</h4>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-button variant="success" v-b-modal.modal-addrep style="width:250px; margin-bottom:20px">ADD A REP</b-button>
            </b-col>
        </b-row>

        <!-- Help -->
        <b-button v-b-modal.modal-helpreps size="sm" variant="outline-secondary">How does this work?  <span style=""><font-awesome-icon icon="question-circle" /></span></b-button>
        <b-modal size = 'lg' id="modal-helpreps"  ok-only title="Managing Reps">
            <ul>
                <li class='question'>Do I have to have a rep?</li>
                <li class='answer'>No. This is optional.</li>
                <li class='question'>What can a rep do?</li>
                <li class='answer'>Accept orders, cancel orders, communicate with buyers. Reps cannot manage inventory at the moment.</li>
                <li class='question'>Which orders will go to the rep?</li>
                <li class='answer'>All orders in a county assigned to a rep will be visible to the rep. Each county can have multiple reps, each rep can handle multiple counties.</li>
                <li class='question'>Can a rep manage multiple breweries?</li>
                <li class='answer'>Yes, a rep can manage multiple breweries.</li>
                <li class='question'>How do I add a sales representative?</li>
                <li class='answer'>Click "Add A Rep"</li>
                <li class='answer'>Enter rep name</li>
                <li class='answer'>Enter rep email. If the rep already has a Keg Seeker account, they will get access to your orders. If the rep does not have an existing accout, a new account will be created for them.</li>
                <li class='answer'>Enter a password. You must enter a password even if the rep has an existing account. If they already have an account, this password will have no effect.</li>
                <li class='answer'>Optionally, enter a rep phone number</li>
                <li class='answer'>Select counties this rep will be responsible for. Each rep can have multiple counties, and each county can have multiple reps. Order emails will go to all reps assigned to a county. </li>
                <li class='question'>How many reps can I have?</li>
                <li class='answer'>Unlimited</li>
                <li class='question'>What if my rep is part of a distribution company</li>
                <li class='answer'>Just add the reps' email. If the rep already has a Keg Seeker account, your account will be added their portfolio. If not, a new account will be created for the rep.
                    Reps can manage different companies and brands.</li>
            </ul>
        </b-modal>
        
        <!--  Add a rep -->
        <b-modal id="modal-addrep" title="ADD A REP" hide-footer size="lg">
            <b-card
                bg-variant="light" 
                border-variant="secondary"
                class="mb-2"
            >
                <b-input-group prepend="Name" class="mt-3">
                    <b-form-input v-model="newRepName" ></b-form-input>
                </b-input-group>
                <b-input-group prepend="Email" class="mt-3">
                    <b-form-input v-model="newRepEmail" ></b-form-input>
                </b-input-group>
                <b-input-group prepend="Password" class="mt-3">
                    <b-form-input v-model="newRepPassword" ></b-form-input>
                </b-input-group>
                <b-input-group prepend="Phone" class="mt-3">
                    <b-form-input v-model="newRepPhone" ></b-form-input>
                </b-input-group>
                <small v-if="this.newRepPassword.length<8">Password must be at least 8 characters</small>
                <br>
                
                <!-- Counties -->
                <hr>
                <b-row>
                    <b-col>
                        <h6>Counties for this Rep</h6>
                        <b-button size="sm" variant="outline-success" @click="selectAllCounties()">SELECT ALL</b-button>
                        <b-button size="sm" variant="outline-danger" @click="unSelectAllCounties()" style="margin-left:10px">UNSELECT ALL</b-button>
                    </b-col>
                </b-row>
                <b-row style="margin-top:10px">
                    <b-col v-for="county in getCounties" :key="county.name">
                        <div v-if="county.isSelected" style="margin-bottom:5px">
                            <b-button :pressed="true" variant="warning" @click="removeCountyFromList(county.name)">{{county.name}} <font-awesome-icon icon="times" /></b-button>
                        </div>
                        <div v-else style="margin-bottom:5px">
                            <b-button variant="success" @click="addToCountyList(county.name)">{{county.name}} </b-button>
                        </div>
                    </b-col>
                </b-row>
                <template #footer>
                    <b-button style="margin-top:10px" variant="info" @click="addRepWithoutCheck()" :disabled='!checkNewRep'>Add Rep</b-button>
                </template>
                
            </b-card>
        </b-modal>

        <!-- All Reps -->
        <b-row>
            <b-card v-for="theRep in userProfile.reps" :key='theRep.uid' style="width:450px; margin:10px"
            header="Primary" header-bg-variant="primary" header-text-variant="white">
                <template #header>
                    <h6 style="text-align:center" class="mb-0">{{theRep.name}}</h6>
                </template>
                <!-- Manage counties -->
                <b-button variant='outline-dark' @click="manageRepCounties(theRep)">Manage Counties</b-button>
                <b-button variant='outline-danger' style="margin-left:10px" @click="showDeleteRepConfirmation(theRep)">Delete Rep</b-button>

                <!-- Modal to edit rep counties -->
                <b-modal :id="'modal-repcounties'+theRep.uid" title="Rep Counties" ok-title="Update" @ok="updateRepCounties(theRep)" @cancel="cancelRepCountyUpdate()">
                    <b-button size="sm" variant="outline-success" @click="selectAllCounties()">SELECT ALL</b-button>
                    <b-button size="sm" variant="outline-danger" @click="unSelectAllCounties()" style="margin-left:10px">UNSELECT ALL</b-button>
                    <b-row style="margin-top:10px">
                        <b-col v-for="county in getCounties" :key="county.name">
                            <div v-if="county.isSelected" style="margin-bottom:5px">
                                <b-button :pressed="true" variant="warning" @click="removeCountyFromList(county.name)">{{county.name}} <font-awesome-icon icon="times" /></b-button>
                            </div>
                            <div v-else style="margin-bottom:5px">
                                <b-button variant="success" @click="addToCountyList(county.name)">{{county.name}} </b-button>
                            </div>
                        </b-col>
                    </b-row>
                </b-modal>
                <!-- Modal to delete rep -->
                <b-modal :id="'modal-deleterep'+theRep.uid" 
                    :title="'Are you sure you want to delete ' + theRep.name +'?'" ok-title="Yes, Delete" @ok="deleteRep(theRep)">
                </b-modal>
            </b-card>
        </b-row>

    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
import axios from 'axios'
const fb = require('../../firebaseConfig.js')
import firebase from 'firebase/app';

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser']),
        checkNewRep(){
            var returnVal=true
            if(this.newRepName.length<2) returnVal=false


            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/.test(this.newRepEmail))
            {
                //returnVal=false
            }
            else returnVal=false

            if(this.newRepPassword.length<8) returnVal=false
            if(this.selectedCounties.length<=0) returnVal=false

            return returnVal
        },

        //Counties
        getCounties(){
            this.allCounties=[]
            var arraySize = this.userProfile.counties.length
            for (var i = 0; i<arraySize; i++){
                var theCounty = {}
                
                theCounty.name = this.userProfile.counties[i]
                var existingCountyindex = -1
                //Check if county in counties list
                if(this.selectedCounties&&this.selectedCounties.length>0 ) existingCountyindex = this.selectedCounties.findIndex(item => item === theCounty.name);
                
                if (existingCountyindex > -1){
                    theCounty.isSelected = true
                } 
                else theCounty.isSelected = false

                this.allCounties.push(theCounty)
            }
            return this.allCounties
        },
    },

    components: {
    },

    data() {
        return {
            newRepName:'',
            newRepEmail:'',
            newRepPassword:'',
            newRepPhone:'',
            errMsg:'',
            addingRep:false,
            performingMessage:'',
            newRepsList:[],

            //Counties
            allCounties:[],
            selectedCounties:[],
            countiesUpdated:false,


        }
    },

    methods:{

        //Add rep without checking for existence of user
        addRepWithoutCheck(){
            console.log("Adding Rep")
            this.performingMessage="Adding Rep"
            this.addingRep=true
            //Change email to lowercase
            this.newRepEmail = this.newRepEmail.toLowerCase();
            //Check if there's an existing reps list
            if(this.userProfile.hasOwnProperty('reps')){
                if(this.userProfile.reps.length>0){
                    this.newRepsList = this.userProfile.reps
                }
            }

            //Check if this email address is already in reps list
            if(this.userProfile.hasOwnProperty('reps')){
                var reps = this.userProfile.reps
                if(reps.length>0){
                    //See if this rep exists
                    const existingRepIndex = reps.findIndex(item => item.email === this.newRepEmail);
                    if (existingRepIndex>-1){
                        this.addingRep=false
                        console.log("Rep email already exists")
                        this.errMsg="This email address is already associated with a Representative of your company"
                        this.$bvModal.show("modal-repexists")
                        return
                    }
                }
            }
            console.log("Adding rep " + this.newRepName)
        
            //Create account for this rep
            this.createRepAccount()

        },

        addRep(){
            this.addingRep=true
            //Change email to lowercase
            this.newRepEmail = this.newRepEmail.toLowerCase();
            //Check if there's an existing reps list
            if(this.userProfile.hasOwnProperty('reps')){
                if(this.userProfile.reps.length>0){
                    this.newRepsList = this.userProfile.reps
                }
            }

            //Check if email address already in use
            fb.auth.signInWithEmailAndPassword(this.newRepEmail, 'some-random-password')  // Password should be really long to avoid actually logging in :)
            .then((response) => {
                //Account already exists

                this.addingRep=false

            })
            .catch((error) => {
                if(error.code === 'auth/wrong-password'){
                    // TODO : If here then it means account already exists...
                    this.errMsg="A user has alredy signed up with this email address"
                    this.$bvModal.show("modal-repexists")
                    this.addingRep=false
                    return
                }

                if(error.code === 'auth/user-not-found'){
                    // No user found. Proceed.
                    //Check if this email address is already in reps list
                    if(this.userProfile.hasOwnProperty('reps')){
                        var reps = this.userProfile.reps
                        if(reps.length>0){
                            //See if this rep exists
                            const existingRepIndex = reps.findIndex(item => item.email === this.newRepEmail);
                            if (existingRepIndex>-1){
                                this.addingRep=false
                                this.errMsg="This email address is already associated with a Representative of your company"
                                this.$bvModal.show("modal-repexists")
                                return
                            }
                        }
                    }
                
                    //Create account for this rep
                    this.createRepAccount()
                }
            })



        },

        //Counties for rep
        addToCountyList(countyName){
            this.selectedCounties.push(countyName)

        },
        removeCountyFromList(countyName){
            var existingCountyindex = this.selectedCounties.findIndex(item => item === countyName);
            if (existingCountyindex > -1){
                this.selectedCounties.splice(existingCountyindex,1)
            }

        },
        selectAllCounties(){
            console.log("Selecting all")
            this.selectedCounties = this.userProfile.counties.slice(0)
        },

        unSelectAllCounties(){
            this.selectedCounties=[]
        },

        //Create rep account using firebase functions
        createRepAccount(){
            var shortName = ''
            shortName = this.newRepName.toLowerCase()
            shortName = shortName.replace(/\s/g, '');
            shortName= shortName.replace(/[^\w\s]/gi, '')

            var theData = {
                email:this.newRepEmail,
                password:this.newRepPassword,
                name: this.newRepName,
                company: this.userProfile.company,
                repcompany:'',
                phone:this.newRepPhone,
                isbrewer: 10, //Rep
                logoFileThumbnailURL: this.userProfile.logoFileThumbnailURL,
                city:this.userProfile.city,
                state:this.userProfile.state,
                street1:this.userProfile.street1,
                street2:this.userProfile.street2,
                zip:this.userProfile.zip,
                county:this.userProfile.county,
                subscription:20,
                orderCount:0,
                licenseUploaded:0,
                licenseFile:'',
                repphotourl:'',
                sendMarketingEmails:1,
                sendOrderEmails:1,
                shortName:shortName,
                counties: this.selectedCounties,
                states:this.userProfile.states,
                allowOrderNotifications:1,
                allowPromoNotifications:1,
                distributorid:this.currentUser.uid,
                brewerid:this.currentUser.uid,
            }

            var addRepFunction = firebase.functions().httpsCallable('addRep');

            addRepFunction(theData)
            .then((result) => {
                // Read result of the Cloud Function.
                this.addingRep=false
                console.log("Got result")
                console.log(result)

                //Check for errors
                if(result.data.code==2){
                    console.log("Rep email already exists")
                    this.errMsg="A user with this email address has already signed up. Ask that user to delete their account and then try again."
                    this.$bvModal.show("modal-repexists")
                    return
                }

                else if(result.data.code==3){
                    console.log("Profile creation error")
                    return
                }
                //Success
                else if(result.data.code==1){
                    var newRepUid = result.data.uid

                    //Add to reps list
                    var newRep = {name: this.newRepName, email: this.newRepEmail, counties:this.selectedCounties, active:1, phone:this.newRepPhone, uid:newRepUid, repphotourl:''}
                    this.newRepsList.push(newRep)
                    
                    fb.usersCollection.doc(this.currentUser.uid).update({
                        reps:this.newRepsList
                    })
                    
                    //Send email to rep
                    var subject = 'You have been added as a Representative for ' + this.userProfile.company

                    var emailhtml = '<html><body>'
                    emailhtml = emailhtml +'<h4>Hello ' +this.newRepName +  '</h4><br>'
                    emailhtml = emailhtml + '<h5>You have been added as a Representative for ' + this.userProfile.company +  '</h5>'
                    //Add KS logo and link
                    emailhtml = emailhtml + "<br>"
                    emailhtml = emailhtml + "<a href='https://www.kegseeker.com/'>"
                    emailhtml = emailhtml + "Login to Keg Seeker to get started"
                    emailhtml = emailhtml + "</a>"
                    emailhtml = emailhtml + "<br>"

                    //Add KS logo and link
                    emailhtml = emailhtml + "<a href='https://www.kegseeker.com/'>"
                    emailhtml = emailhtml + "<img src='https://res.cloudinary.com/lo4xxr5lr/image/upload/v1601714861/icons/KS_Blue_1_small.png'>"
                    emailhtml = emailhtml + "</a>"
                    emailhtml = emailhtml + '</body></html>'

                    //Send the email

                    var mailData = {
                        to:this.newRepEmail,
                        replyTo:this.currentUser.email,
                        from: this.userProfile.company +" <" + this.currentUser.email+">",
                        message:{
                            subject:subject,
                            html:emailhtml
                        }
                    }

                    //fb.mailCollection.add(mailData)
                    fb.emailToEmailCollection.add(mailData)

                    this.$bvToast.toast(this.newRepName + ' has been added', {
                        title: 'Rep Added!',
                        solid:true,
                        variant: 'success',
                        autoHideDelay: 5000,
                        appendToast: false
                    })
                    this.newRepName=""
                    this.newRepEmail=""
                    this.selectedCounties=[]
                    this.newRepPhone=''
                    this.newRepPassword=''
            }

            })
            .catch(error => {
                console.log("Web: Account creation error, FB error = ")
                console.log(error)
                this.addingRep=false
            });

        },

        //Manage rep counties
        manageRepCounties(theRep){
            this.selectedCounties=theRep.counties
            this.$bvModal.show("modal-repcounties"+theRep.uid)
        },
        updateRepCounties(theRep){
            this.performingMessage="Updating Counties"
            this.addingRep=true
            //Update distributor db
            var newRepsList = []
            for (var i=0; i<this.userProfile.reps.length; i++){
                var thisRep = this.userProfile.reps[i]
                if(thisRep.uid==theRep.uid) thisRep.counties = this.selectedCounties
                newRepsList.push(thisRep)
            } 
            //Update distributor
            fb.usersCollection.doc(this.currentUser.uid).update({
                reps:newRepsList,
            })

            //Update rep profile
            var updaterepcountiesfunction = firebase.functions().httpsCallable('updaterepcounties');
            var theData = {
                repid:theRep.uid,
                brewerid:this.currentUser.uid,
                counties:this.selectedCounties,
            }
            updaterepcountiesfunction(theData)

            this.$bvToast.toast(this.newRepName + ' Counties have been updated', {
                    title: 'Counties updated',
                    solid:true,
                    variant: 'success',
                    autoHideDelay: 5000,
                    appendToast: false
                })
            this.addingRep=false
            this.selectedCounties=[]

        },
        cancelRepCountyUpdate(){
            this.selectedCounties=[]
        },

        //Delete Rep confirmation
        showDeleteRepConfirmation(theRep){
            this.$bvModal.show("modal-deleterep"+theRep.uid)
        },

        //Delete Rep
        deleteRep(theRep){
            this.performingMessage="Deleting Rep"
            this.addingRep=true
            //Update distributor profile to remove this rep
            var newRepsList = []
            for (var i=0; i<this.userProfile.reps.length; i++){
                var thisRep = this.userProfile.reps[i]
                if(thisRep.uid==theRep.uid){
                    //Skip rep
                }
                else newRepsList.push(thisRep)
            } 
            //Update distributor
            fb.usersCollection.doc(this.currentUser.uid).update({
                reps:newRepsList,
            })
            //Delete rep account
            var deleteRepFunction = firebase.functions().httpsCallable('removerep');
            var theData = {
                uid:theRep.uid,
                brewerid:this.currentUser.uid
            }
            deleteRepFunction(theData)
            .then((result) => {
                console.log("Delete result = ")
                console.log(result.data)
            })
            this.addingRep=false

            this.$bvToast.toast(theRep.name + ' has been deleted', {
                    title: 'Rep Deleted!',
                    solid:true,
                    variant: 'success',
                    autoHideDelay: 5000,
                    appendToast: false
                })
        },
        

    },

    mounted(){
    },
}
</script>

<style scoped>
.question{
    color:#F7882F
}
.answer{
    padding-left:20px
}
</style>